import { DownloadOutlined, RedoOutlined } from "@ant-design/icons";
import { useIsFetching, useQuery } from "@tanstack/react-query";
import { Space, Button } from "antd";
import dayjs from "dayjs";
import React, { useState, useCallback } from "react";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { ChartDatePicker, Co2Chart, co2ChartQueryOptions } from "./Co2Chart";
import { BaseChartProps } from "./TemperatureCableChart";
import { RangeValue } from "./ChartContainer";
import { BaseChartQueryOptions, useAddDefaultAnnotationsToCsv } from "./modehistoryAndFanChangeHistory";
import { CSVLink } from "react-csv";
import { CsvButton } from "./csv/CsvButton";
import { timestampHeader } from "./csv/core";


export const Co2ChartTab = (props: BaseChartProps) => {
    const currentDate = dayjs();
    const priorDate = currentDate.subtract(7, 'days');
  
  
    const isControlled = typeof props.value != 'undefined';
    const [internalValue, setIntervalValue] = useState<RangeValue>([priorDate, currentDate]);
    const inprogress = useIsFetching([...binDBKeys.bin(props.binId), "charts"]);
  
    // Internally, we need to deal with some value. Depending on whether
    // the component is controlled or not, that value comes from its
    // props or from its internal state.
  
    const value = isControlled ? props.value : internalValue;
  
  
    const onDateChange = useCallback((values: RangeValue, formatter?: any) => {
        if (props.onChange) {
          props.onChange(values);
        }
        else {
          setIntervalValue(values);
        }
      }, [props.onChange]);

    return <>
        <div>
            <Space direction="horizontal" wrap>
                <ChartDatePicker startDate={value?.[0]!} endDate={value?.[1]!} onDateRangeChange={onDateChange} />
                <Button type="primary" disabled={inprogress > 0} icon={<RedoOutlined spin={inprogress > 0} />} onClick={() => {
                    onDateChange([value?.[0]!, dayjs()], ['', '']);
                }}>
                </Button>
                <Co2CSV binId={props.binId} range={value} />

            </Space>

            <div style={{ width: "100%" }}>
                <Co2Chart binId={props.binId} deviceId={props.deviceId} value={value} />
            </div>
        </div>
    </>

}

export const Co2CSV = (props: BaseChartQueryOptions) => {
    const co2Header = "CO2 (PPM)";

    const _co2ChartQueryOptions = co2ChartQueryOptions({ binId: props.binId, range: props.range });
    const co2ChartQuery = useQuery({ ..._co2ChartQueryOptions });

    const baseData = co2ChartQuery.data?.data
        ?.map(row => ({ [timestampHeader]: row.x, [co2Header]: row.y })) ?? [];

    const finalCsv = useAddDefaultAnnotationsToCsv({
        baseData: baseData,
        baseHeaders: [timestampHeader, co2Header],
        binId: props.binId, range: props.range,
    });

    return <CsvButton data={finalCsv.data} headers={finalCsv.headers} baseFileName="co2" />

}